import { amplifyProxy } from '@/services/directApi'

export default {
  namespaced: true,
  state: {
    bankAccounts: '',
    loading: {
      accounts: false,
      authorize: false,
      linkable: false,
      link: false,
      unlink: false
    },
    error: {
      accounts: null,
      authorize: null,
      linkable: null,
      link: null,
      unlink: null
    }
  },
  mutations: {
    SET_BANK_ACCOUNTS(state, data) {
      state.bankAccounts = data
    },
    SET_LOADING(state, { type, value }) {
      state.loading[type] = value
    },
    SET_ERROR(state, { type, error }) {
      state.error[type] = error
    }
  },
  actions: {
    async getBankAccounts({ commit, rootState }) {
      commit('SET_LOADING', { type: 'accounts', value: true })
      commit('SET_ERROR', { type: 'accounts', error: null })

      try {
        const response = await amplifyProxy.get(`/${rootState.user.ClientName}/openbanking/accounts/system`, {
          headers: {
            token: rootState.user.LoginToken,

          }
        })
        commit('SET_BANK_ACCOUNTS', response.data)
        return response.data
      } catch (error) {
        commit('SET_ERROR', { type: 'accounts', error: error.message })
        throw error
      } finally {
        commit('SET_LOADING', { type: 'accounts', value: false })
      }
    },

    async authorizeAccount({ commit, rootState }, bankID) {
      commit('SET_LOADING', { type: 'authorize', value: true })
      commit('SET_ERROR', { type: 'authorize', error: null })

      try {
        const response = await amplifyProxy.post(`/${rootState.user.ClientName}/openbanking/authorize/${bankID}`, {}, {
          headers: {
            token: rootState.user.LoginToken,

          }
        })
        return response
      } catch (error) {
        commit('SET_ERROR', { type: 'authorize', error: error.message })
        throw error
      } finally {
        commit('SET_LOADING', { type: 'authorize', value: false })
      }
    },

    async linkableAccount({ commit, rootState }, bankID) {
      commit('SET_LOADING', { type: 'linkable', value: true })
      commit('SET_ERROR', { type: 'linkable', error: null })

      try {
        const response = await amplifyProxy.get(`/${rootState.user.ClientName}/openbanking/accounts/system/${bankID}/linkableAccounts`, {
          headers: {
            token: rootState.user.LoginToken,

          }
        })
        return response
      } catch (error) {
        commit('SET_ERROR', { type: 'linkable', error: error.message })
        throw error
      } finally {
        commit('SET_LOADING', { type: 'linkable', value: false })
      }
    },

    async linkAccount({ commit, rootState }, credentials) {
      commit('SET_LOADING', { type: 'link', value: true })
      commit('SET_ERROR', { type: 'link', error: null })

      try {
        const response = await amplifyProxy.post(`/${rootState.user.ClientName}/openbanking/accounts/system/${credentials.systemBancAccountID}/link/${credentials.openBankingAccountID}`, {}, {
          headers: {
            token: rootState.user.LoginToken,

          }
        })
        return response
      } catch (error) {
        commit('SET_ERROR', { type: 'link', error: error.message })
        throw error
      } finally {
        commit('SET_LOADING', { type: 'link', value: false })
      }
    },

    async unlinkAccount({ commit, rootState }, accountID) {
      commit('SET_LOADING', { type: 'unlink', value: true })
      commit('SET_ERROR', { type: 'unlink', error: null })

      try {
        const response = await amplifyProxy.post(`/${rootState.user.ClientName}/openbanking/accounts/system/${accountID}/unlink`, {}, {
          headers: {
            token: rootState.user.LoginToken,

          }
        })
        return response
      } catch (error) {
        commit('SET_ERROR', { type: 'unlink', error: error.message })
        throw error
      } finally {
        commit('SET_LOADING', { type: 'unlink', value: false })
      }
    }
  }
}